import { gql } from "@apollo/client";

export const GET_PATIENT_NOTES_BY_PATIENT_ID = gql`
  query PatientNotesByPatientId($patient_id: ID!) {
    patientNotesByPatientId(patient_id: $patient_id) {
      _id
      patient_id
      date
      content
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATIENT_NOTE_BY_ID = gql`
  query PatientNoteById($id: ID!) {
    patientNoteById(_id: $id) {
      _id
      patient_id
      date
      content
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATIENT_NOTES_BY_IDS = gql`
  query PatientNotesByIds($ids: [ID!]!) {
    patientNotesByIds(ids: $ids) {
      _id
      patient_id
      date
      content
      createdAt
      updatedAt
    }
  }
`;
